import apiClient from '../middleware/apiClient';
import { ACCOUNT_NAME } from '../helpers/apis';

export const GET_ACCOUNT_NAME = 'GET_ACCOUNT_NAME';
export const GET_ACCOUNT_NAME_SUCCESS = 'GET_ACCOUNT_NAME_SUCCESS';
export const GET_ACCOUNT_NAME_FAILURE = 'GET_ACCOUNT_NAME_FAILURE';

function dispatchGetAccountName() {
  return {
    type: GET_ACCOUNT_NAME,
    payload: apiClient.fetch(ACCOUNT_NAME),
  };
}

function dispatchGetAccountNameSuccess(data) {
  return {
    type: GET_ACCOUNT_NAME_SUCCESS,
    payload: data,
  };
}

function dispatchGetAccountNameFailure(error) {
  return {
    type: GET_ACCOUNT_NAME_FAILURE,
    payload: error,
  };
}

const getAccountName = () => async (dispatch, getState) => {
  const {
    accountName: { cached } = {},
  } = getState();

  if (cached) {
    return null;
  }

  try {
    const response = await dispatch(dispatchGetAccountName()).payload;
    return dispatch(dispatchGetAccountNameSuccess(response));
  } catch (error) {
    dispatch(dispatchGetAccountNameFailure(error));
    throw error;
  }
};

export default getAccountName;
